module.exports = __webpack_public_path__ + "static/img/3.bb01749.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/home-en/3.png
// module id = SDQw
// module chunks = 0